<template>
  <div id="app" class="g-app">
    <router-view />
  </div>
</template>

<script>
import "./assets/css/element-ui.less";
// import "swiper/css/swiper.min.css";
import "swiper/swiper.less";

import "./assets/css/reset.less";
import "./assets/css/quill.snow.css";
import "./assets/css/style.less";
import "./assets/css/media.less";

export default {
  name: "app",
  data() {
    return {};
  },
  computed: {},
  components: {},
  mounted() {
    console.log(this.$store.state);
  },
  methods: {}
};
</script>
<style lang="less">
@font-face {
  font-family: "en-tit";
  src: url("./assets/css/fonts/BebasNeue-1.otf");
}
@font-face {
  font-family: "dream";
  src: url("./assets/css/fonts/dream.TTF");
}
</style>
